import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/kadis'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(kadis) {
    return http.post(`${resource}`, kadis, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  getParams(uuid, params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}/detail-school/${uuid}${paramsString}`)
  },
  update(kadis, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, kadis, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
